import { render } from "./ContactAddress.vue?vue&type=template&id=24f78cbe"
import script from "./ContactAddress.vue?vue&type=script&lang=js"
export * from "./ContactAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__